(function () {
  'use strict';

  var endpoint = '/apps/distributor/public-directory';
  var distributorRequest;

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function clean(value) {
    return value == null ? '' : String(value).trim();
  }

  function asArray(data) {
    var fields = ['country', 'company_name', 'phone', 'email', 'url', 'company_logo'];
    if (!Array.isArray(data) || !data.every(function (item) {
      if (!item || !fields.every(function (field) { return typeof item[field] === 'string'; })) return false;
      if (!item.country.trim() || !item.company_name.trim()) return false;
      return ['url', 'company_logo'].every(function (field) {
        if (!item[field]) return true;
        try {
          var url = new URL(item[field]);
          return (url.protocol === 'https:' || (field === 'url' && url.protocol === 'http:')) && !url.username && !url.password && url.hostname !== 'd.biossusa.com';
        } catch (error) { return false; }
      });
    })) throw new Error('Invalid public distributor response');
    return data;
  }

  function normalizeUrl(value) {
    var url = clean(value);
    if (!url) return '';
    if (/^https?:\/\//i.test(url)) return url;
    return 'https://' + url.replace(/^\/+/, '');
  }

  function normalizeImage(value) {
    var image = clean(value);
    if (!image) return '';
    if (/^(data:image|https?:\/\/|\/\/)/i.test(image)) return image;
    return 'data:image/png;base64,' + image;
  }

  function normalizeDistributor(item) {
    item = item || {};
    var distributor = item.distributor || {};
    var user = item.user || {};

    return {
      country: clean(item.country),
      company: clean(item.company_name || distributor.company_name || distributor.name || user.username || item.name),
      phone: clean(item.phone || distributor.phone_public || distributor.phone),
      email: clean(item.email || user.email || distributor.email),
      url: normalizeUrl(item.url || distributor.url || user.url),
      logo: normalizeImage(item.company_logo || item.logo || distributor.logo)
    };
  }

  function fetchDistributors() {
    if (!distributorRequest) {
      distributorRequest = fetch(endpoint, { credentials: 'omit' })
        .then(function (response) {
          if (!response.ok) throw new Error('Distributor request failed');
          return response.json();
        })
        .then(function (data) {
          return asArray(data).map(normalizeDistributor).filter(function (item) {
            return item.country && item.company;
          });
        });
    }
    return distributorRequest;
  }

  function appendText(parent, tagName, className, value) {
    if (!value) return null;
    var node = document.createElement(tagName);
    if (className) node.className = className;
    node.textContent = value;
    parent.appendChild(node);
    return node;
  }

  function distributorCard(item) {
    var card = document.createElement('article');
    card.className = 'bioss-product-distributor__card';

    var details = document.createElement('div');
    details.className = 'bioss-product-distributor__details';
    appendText(details, 'h5', 'bioss-product-distributor__company', item.company);

    if (item.phone) {
      var phone = document.createElement('a');
      phone.className = 'bioss-product-distributor__link';
      phone.href = 'tel:' + item.phone.replace(/[^+\d]/g, '');
      phone.textContent = item.phone;
      details.appendChild(phone);
    }

    if (item.email) {
      var email = document.createElement('a');
      email.className = 'bioss-product-distributor__link';
      email.href = 'mailto:' + item.email;
      email.textContent = item.email;
      details.appendChild(email);
    }

    if (item.url) {
      var website = document.createElement('a');
      website.className = 'bioss-product-distributor__website';
      website.href = item.url;
      website.target = '_blank';
      website.rel = 'noopener';
      website.textContent = 'Visit website';
      details.appendChild(website);
    }

    card.appendChild(details);

    if (item.logo) {
      var logoWrap = document.createElement('div');
      logoWrap.className = 'bioss-product-distributor__logo-wrap';
      var logo = document.createElement('img');
      logo.className = 'bioss-product-distributor__logo';
      logo.src = item.logo;
      logo.alt = item.company + ' logo';
      logo.loading = 'lazy';
      logoWrap.appendChild(logo);
      card.appendChild(logoWrap);
    }

    return card;
  }

  function initialize(root) {
    var select = root.querySelector('[data-bioss-product-distributor-country]');
    var status = root.querySelector('[data-bioss-product-distributor-status]');
    var results = root.querySelector('[data-bioss-product-distributor-results]');

    fetchDistributors().then(function (items) {
      var countries = [];
      var seen = Object.create(null);

      items.forEach(function (item) {
        if (!seen[item.country]) {
          seen[item.country] = true;
          countries.push(item.country);
        }
      });
      countries.sort(function (a, b) { return a.localeCompare(b); });

      select.innerHTML = '';
      var prompt = document.createElement('option');
      prompt.value = '';
      prompt.textContent = 'Select a Country';
      select.appendChild(prompt);

      countries.forEach(function (country) {
        var option = document.createElement('option');
        option.value = country;
        option.textContent = country;
        select.appendChild(option);
      });

      select.disabled = !countries.length;
      status.textContent = countries.length ? '' : 'No distributor contacts are currently listed. Please email orders@biossusa.com for assistance.';

      select.addEventListener('change', function () {
        var country = select.value;
        results.innerHTML = '';

        if (!country) {
          status.textContent = '';
          return;
        }

        var matches = items.filter(function (item) { return item.country === country; });
        if (!matches.length) {
          status.textContent = 'No distributor information is currently available for ' + country + '.';
          return;
        }

        status.textContent = matches.length === 1
          ? 'Your local Bioss distributor:'
          : 'Your local Bioss distributors:';
        matches.forEach(function (item) { results.appendChild(distributorCard(item)); });
      });
    }).catch(function () {
      select.innerHTML = '<option value="">Select a Country</option>';
      select.disabled = true;
      status.innerHTML = 'Distributor information is temporarily unavailable. Please email <a href="mailto:orders@biossusa.com">orders@biossusa.com</a> for assistance.';
    });
  }

  ready(function () {
    var finders = document.querySelectorAll('[data-bioss-product-distributor-finder]');
    Array.prototype.forEach.call(finders, initialize);
  });
})();
